<template>
  <q-btn-dropdown
    :hover-reveal="false"
    split
    :label="getLabel"
    :class="klass"
    @click="click"
    no-hover
    :no-ripple="true"
  >
    <!-- dropdown content -->
    <q-list link>
      <q-item @click.native="moveLeft">
        <q-item-main>
          <q-item-tile label>Move left</q-item-tile>
        </q-item-main>
      </q-item>
      <q-item @click.native="moveRight">
        <q-item-main>
          <q-item-tile label>Move right</q-item-tile>
        </q-item-main>
      </q-item>
    </q-list>
  </q-btn-dropdown>
</template>

<script>
export default {
  props: {
    tab: {
      type: Object,
      required: true
    },
    tabs: {
      type: Array,
      required: true
    }
  },
  mounted() {
    // this removes the hover from the tab buttons
    let tabButtons = document.querySelector(
      ".tab-btns > button.q-btn.inline.relative-position.q-btn-item.non-selectable.q-btn-rectangle.q-focusable.q-hoverable.q-btn-dropdown-current"
    );
    tabButtons.classList.remove("q-hoverable");
    tabButtons.classList.remove("q-focusable");
    let tabDropDownArrow = document.querySelector(
      ".tab-btns > button.q-btn.inline.relative-position.q-btn-item.non-selectable.q-btn-dropdown-arrow.q-btn-rectangle.q-focusable.q-hoverable"
    );
    tabDropDownArrow.classList.remove("q-hoverable");
    tabDropDownArrow.classList.remove("q-focusable");
  },

  computed: {
    active() {
      if (this.tab && this.$store.getters.getDragEditorActiveTab) {
        return (
          this.$store.getters.getDragEditorActiveTab.name === this.tab.name
        );
      }
    },
    klass() {
      let arr = ['tab-btns'];
      if (this.active) {
        arr.push("active-tab");
      }
      return arr;
    },
    // this can be deprecated once all tab titles disappeared
    // we only use tab labels going forward
    getLabel() {
      if (this.tab.label) {
        return this.tab.label;
      } else {
        return this.tab.title;
      }
    }
  },
  methods: {
    click() {
      this.$store.commit("SET_DRAG_EDITOR_ACTIVE", this.tab);
      this.$store.commit("SET_DRAG_EDITOR_ACTIVE_TAB", this.tab);
    },
    moveRight() {
      let current_tab_index = this.tabs.indexOf(this.tab);
      let new_tab_index = current_tab_index + 1;

      if (current_tab_index == this.tabs.length) {
        return;
      }

      this.reArrangeTabs(new_tab_index, this.tabs, this.tab);
    },
    moveLeft() {
      let current_tab_index = this.tabs.indexOf(this.tab);
      let new_tab_index = current_tab_index - 1;

      if (current_tab_index == 0) {
        return;
      }

      this.reArrangeTabs(new_tab_index, this.tabs, this.tab);
    },
    reArrangeTabs(new_tab_index, tabs, tab) {
      _.remove(tabs, tab);

      tabs.splice(new_tab_index, 0, tab);
      this.$store.commit("SET_DRAG_EDITOR_ACTIVE", tab);
      this.$store.commit("SET_DRAG_EDITOR_ACTIVE_TAB", tab);
      this.$store.commit("SET_DRAG_EDITOR_EDITED", true);
    }
  }
};
</script>

<style lang="sass">
.tab-btns
  .q-btn
    text-transform: none !important
</style>

<style lang="sass" scoped>
.q-item:last-child
  border-bottom: 0px solid $paper
  color: #9198AB
.drag-tab
  max-width: 250px
  padding: 4px 10px
  border: 1px solid #dbdbdb
  border-radius: 7px
  background: #F4F5F8
  cursor: pointer
  user-select: none
  margin-right: 15px
.drag-tab-container
  .active-tab
    border-color: #1B88FD !important

  .q-btn-item
    &:hover, &:before, &:after
      border-color: #1B88FD !important

.q-popover
  box-shadow: 0 20px 66px 0 rgba(34,48,73,0.2) !important
  border-radius: 4px
  min-width: 160px !important
  .q-list
    padding: 2px 0px
    .q-item
      padding: 10px 30px
      min-height: 42px
      font-size: 14px
      font-weight: $font-medium
      color: $ink-lighter
      border-bottom: 1px solid $paper
      transition: all .15s ease-out
      &:last-child
        border-bottom: 0px solid $paper
      &:hover
        background: $paper-lighter !important
        color: $ink
.q-btn-group.row.no-wrap.inline.q-btn-dropdown.q-btn-dropdown-split.no-wrap.q-btn-item
  margin-top: 10px
</style>



// WEBPACK FOOTER //
// DragTab.vue?1cf34415